import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { connect } from 'react-redux';

class NewApi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copySuccess: '',
    };
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  copyToClipboard(e) {
    this.newtoken.select();
    document.execCommand('copy');
    e.target.focus();
    this.setState({ copySuccess: 'Copied!' });
  }

  render() {
    const { newtoken, tempAnon } = this.props;
    const { copySuccess } = this.state;

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">New Token Created</div>
            <div className="modal-subheading">
              Please copy the token below, and make note of your reference ID. You will not be able to view the token again.
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <div className="input-copy-wrap">
              <div className="input-wrapper">
                <input
                  className="modal-input"
                  type={tempAnon ? 'password' : 'text'}
                  name="newtoken"
                  placeholder="New Token"
                  value={newtoken ? newtoken.token : ''}
                  readOnly
                  ref={(newtoken) => this.newtoken = newtoken} />
              </div>
              <button type="button" className="vlt-button" onClick={this.copyToClipboard}>
                <span>
                  <FontAwesomeIcon
                    style={{
                      color: '#9b4c25',
                    }}
                    size="lg"
                    icon={faCopy}
                  />
                </span>
              </button>
            </div>
          </div>
          {copySuccess && (
            <div className="cell small-12 medium-12 large-12">
              <div style={{ paddingBottom: 16, color: 'rgb(36, 195, 126)' }}>{copySuccess}</div>
            </div>
          )}
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-subheading">
              Make note of your token&apos;s reference ID for future reference.
            </div>
            <div>
              <span className={tempAnon ? 'eyeblur' : ''}>
                {newtoken ? newtoken.referenceId : ''}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  newtoken: state.user.newtoken,
  tempAnon: state.user.tempAnon,
});

export default connect(mapStateToProps)(NewApi);
